import React, { useContext, useEffect, useState } from "react";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useFirestore } from "../firebase/FirestoreContext";
import { getDocs, collection } from "firebase/firestore";
import { EnvContext } from "../../context/EnvContext";
import config from "../../config";

const FAQ = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const environment = useContext(EnvContext);
  const db = useFirestore();
  const [faqList, setFaqList] = useState([]);

  const collectionPath = environment === "staging" ? config.enveironment.staging.collectionPath : config.enveironment.production.collectionPath;

  const fetchFAQs = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, `${collectionPath}Help/FAQ/DataBase`));
      const faqArray = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setFaqList(faqArray);
    } catch (error) {
      console.error("Error fetching FAQ entries:", error);
    }
  };

  useEffect(() => {
    fetchFAQs();
  }, [db, environment, location]);

  return (
    <div>
      <div style={styles.header}>
        <h2>
          {environment === "staging" && <span style={{ background: "#dae121", marginRight: 5 }}>Staging</span>}
          FAQ
        </h2>
        <div style={styles.buttonGroup}>
          <Link to={`/main/faq/new`}>
            <button style={styles.button}>New FAQ</button>
          </Link>
        </div>
      </div>

      <table style={styles.table}>
        <thead>
          <tr style={{ backgroundColor: "rgba(49,57,66,.1)" }}>
            <th style={{ ...styles.th, width: "120px" }}>FAQ ID</th>
            <th style={styles.th}>Question</th>
            <th style={styles.th}>Answer</th>
          </tr>
        </thead>
        <tbody>
          {faqList.map((item) => (
            <tr key={item.id} style={styles.clickableRow} onClick={() => navigate(`/main/faq/edit/${item.id}`)}>
              <td style={styles.td}>{item.id.substring(0, 8).toUpperCase()}</td>
              <td style={styles.tdName}>{item.question}</td>
              <td style={{ ...styles.td }}> {item.answer.length > 100 ? item.answer.substring(0, 100) + "..." : item.answer}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <Outlet context={{ refreshFAQs: fetchFAQs }} />
    </div>
  );
};

const styles = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px",
    backgroundColor: "white",
    borderBottom: "1px solid #ccc",
  },
  button: {
    padding: "0px",
    width: "120px",
    backgroundColor: "#313942",
    color: "white",
    border: "none",
    cursor: "pointer",
    fontSize: "14px",
    height: "50px",
  },
  buttonGroup: {
    display: "flex",
    gap: "10px",
  },
  table: {
    borderCollapse: "collapse",
    width: "100%",
  },
  th: {
    border: "1px solid #d1d0d0",
    padding: "8px",
    textAlign: "left",
  },
  td: {
    border: "1px solid #d1d0d0",
    padding: "8px",
    color: "gray",
  },
  tdName: {
    border: "1px solid #d1d0d0",
    padding: "8px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  clickableRow: {
    cursor: "pointer",
  },
};

export default FAQ;
